import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
    } = config;
    this.body = document.querySelector('body');
    const lvl0Toggles =  document.querySelectorAll('.main-menu__item--level-0.main-menu__item--has-children > .main-menu__link');
    const lvl1Toggles =  document.querySelectorAll('.main-menu__item--level-1.main-menu__item--has-children > .main-menu__link');
    const lvl1Backs =  document.querySelectorAll('.js-menu-item-back--level-1');
    const lvl2Backs =  document.querySelectorAll('.js-menu-item-back--level-2');
    const lvl1Contents = document.querySelectorAll('.main-menu__inner--level-1');
    const subContainer = document.querySelectorAll('.main-menu__wrap--level-1');
    const burgers = document.querySelectorAll('.js-menu-toggle');
    const searchToggles = document.querySelectorAll('.js-search-toggle');
    const menuWrapper = document.querySelector('.header__menu');

    const backDrop = document.querySelector('.menu-backdrop');

    this.positionLvl1([...lvl1Contents]);
    window.addEventListener("resize", () => {
      this.positionLvl1([...lvl1Contents]);
    });

    [...subContainer].forEach(container => {
      const closeBtn = document.createElement('div');
      Helper.addClass(closeBtn, 'js-colose-lvl-1');
      Helper.addClass(closeBtn, 'main-menu__close-lvl-1');
      container.prepend(closeBtn);
      closeBtn.addEventListener('click', e => {
        this.subMenuClose([...lvl0Toggles], 'lvl-0-open');
      });
    });

    [...searchToggles].forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        Helper.toggleClass(toggle, 'search-active');
        Helper.toggleClass(this.body, 'search-open');
      });
    });

    [...burgers].forEach(burger => {
      burger.addEventListener('click', e => {
        e.preventDefault();
        Helper.toggleClass(burger, 'burger-active');
        Helper.toggleClass(this.body, 'menu-open');
        Helper.toggleClass(menuWrapper, 'is-open');
      });
    });

    [...lvl1Backs].forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        this.subMenuClose([...lvl0Toggles], 'lvl-0-open');
      });
    });

    [...lvl2Backs].forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        this.subMenuClose([...lvl1Toggles], 'lvl-1-open');
      });
    });

    [...lvl0Toggles].forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        this.subMenuToggle([...lvl0Toggles], toggle, 'lvl-0-open');
      });
    });

    [...lvl1Toggles].forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        this.subMenuToggle([...lvl1Toggles], toggle, 'lvl-1-open');
      });
    });

    backDrop.addEventListener('click', e => {
      e.preventDefault();
      this.subMenuClose([...lvl0Toggles], 'lvl-0-open');
    });

  }

  positionLvl1(lvl1){
    const firstItem = document.querySelector('li:first-child.main-menu__item--level-0 .main-menu__link');
    lvl1.forEach(container => {
      container.style.left = firstItem.getBoundingClientRect().left+'px';
    });
  }

  subMenuToggle(togglerArray, currentToggle, bodyClass){
    togglerArray.forEach(toggler => {
      if(toggler != currentToggle){
        Helper.removeClass(toggler, 'active');
        Helper.removeClass(toggler.nextElementSibling, 'is-open');
      }
    });
    Helper.toggleClass(currentToggle, 'active');
    Helper.toggleClass(currentToggle.nextElementSibling, 'is-open');
    if(Helper.hasClass(currentToggle, 'active')){
      Helper.addClass(this.body, bodyClass);
    } else {
      Helper.removeClass(this.body, bodyClass);
    }
  }

  subMenuClose(togglerArray, bodyClass){
    togglerArray.forEach(toggle => {
      Helper.removeClass(toggle, 'active');
      Helper.removeClass(toggle.nextElementSibling, 'is-open');
    });
    Helper.removeClass(this.body, bodyClass);
  }

}

export default Header;
